import React, { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import BrandlyLogo from "../../assets/BrandlyLogo.png";
import useAuthStore from "../../stores/authStore";

const API_URL = process.env.REACT_APP_API_URL;

function Navbar() {
  const { user, clearUser } = useAuthStore();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  

  // separate dropdown states
  const [isDesktopDropdownOpen, setIsDesktopDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);

  const [isNavbarSidebarOpen, setIsNavbarSidebarOpen] = useState(false);
  const dropdownTimeoutRef = React.useRef(null);

  const handleMouseEnter = () => {
  if (dropdownTimeoutRef.current) {
    clearTimeout(dropdownTimeoutRef.current);
  }
  setIsDesktopDropdownOpen(true);
};

const handleMouseLeave = () => {
  dropdownTimeoutRef.current = setTimeout(() => {
    setIsDesktopDropdownOpen(false);
  }, 200); // 200ms delay before closing
};

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await fetch(`${API_URL}/auth/logout`, {
        method: "GET",
        credentials: "include",
      });
    } catch (err) {
      console.warn("Logout fetch error (ignored):", err);
    } finally {
      clearUser();
      navigate("/");
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" onClick={() => setIsNavbarSidebarOpen(false)}>
          <img src={BrandlyLogo} alt="Brandly" className="logo" />
        </Link>

        {/* Desktop Nav */}
        <div className="nav-links desktop-nav">
          <NavLink to="/about" className="nav-item">
            About
          </NavLink>

          {/* Free Tools Dropdown (desktop hover) */}
          <div
  className="nav-item dropdown-n"
  onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave}
>
  Free Tools <span className="arrow">▾</span>
  {isDesktopDropdownOpen && (
    <div
      className="dropdown-menu"
      onMouseEnter={handleMouseEnter}   // keep it open if hovering inside
      onMouseLeave={handleMouseLeave}
    >
      <NavLink to="/linkedin-video-downloader" className="dropdown-item">
        LinkedIn Video Downloader
      </NavLink>
      <NavLink to="/linkedin-summary-generator" className="dropdown-item">
        LinkedIn Summary Generator
      </NavLink>
      <NavLink to="/linkedin-headline-generator" className="dropdown-item">
        LinkedIn Headline Generator
      </NavLink>
    </div>
  )}
</div>

          <NavLink to="/pricing" className="nav-item">
            Pricing
          </NavLink>
          <NavLink to="/blogs" className="nav-item">
            Blogs
          </NavLink>
        </div>

        {/* Desktop Buttons */}
        <div className="desktop-nav">
          {user ? (
            <button
              className="login-button logout-button"
              onClick={handleLogout}
              disabled={isLoggingOut}
            >
              {isLoggingOut ? <div className="spinner"></div> : "Logout"}
            </button>
          ) : (
            <Link to="/login">
              <button className="login-button">LogIn</button>
            </Link>
          )}
        </div>

        {/* Hamburger for mobile */}
        <button
          className="hamburger"
          onClick={() => setIsNavbarSidebarOpen(true)}
          aria-label="Open menu"
        >
          ☰
        </button>
      </div>

      {/* Backdrop */}
      <div
        className={`navbar-backdrop ${isNavbarSidebarOpen ? "visible" : ""}`}
        onClick={() => setIsNavbarSidebarOpen(false)}
      />

      {/* Sidebar (Mobile) */}
      <aside className={`navbar-sidebar ${isNavbarSidebarOpen ? "open" : ""}`}>
        <button className="navbar-close-btn" onClick={() => setIsNavbarSidebarOpen(false)}>
          ✕
        </button>

        <NavLink
          to="/about"
          className="navbar-sidebar-item"
          onClick={() => setIsNavbarSidebarOpen(false)}
        >
          About
        </NavLink>

        {/* Sidebar Dropdown (click to toggle) */}
        <div
          className="navbar-sidebar-item dropdown-n"
          onClick={() => setIsMobileDropdownOpen(!isMobileDropdownOpen)}
        >
          Free Tools ▾
          {isMobileDropdownOpen && (
            <div className="dropdown-menu">
              <NavLink
                to="/linkedin-video-downloader"
                className="dropdown-item"
                onClick={() => setIsNavbarSidebarOpen(false)}
              >
                LinkedIn Video Downloader
              </NavLink>
              <NavLink
                to="/linkedin-summary-generator"
                className="dropdown-item"
                onClick={() => setIsNavbarSidebarOpen(false)}
              >
                LinkedIn Summary Generator
              </NavLink>
              <NavLink
                to="/linkedin-headline-generator"
                className="dropdown-item"
                onClick={() => setIsNavbarSidebarOpen(false)}
              >
                LinkedIn Headline Generator
              </NavLink>
            </div>
          )}
        </div>

        <NavLink
          to="/pricing"
          className="navbar-sidebar-item"
          onClick={() => setIsNavbarSidebarOpen(false)}
        >
          Pricing
        </NavLink>
        <NavLink
          to="/blogs"
          className="navbar-sidebar-item"
          onClick={() => setIsNavbarSidebarOpen(false)}
        >
          Blogs
        </NavLink>

        {user ? (
          <button
            className="login-button logout-button"
            onClick={() => {
              handleLogout();
              setIsNavbarSidebarOpen(false);
            }}
            disabled={isLoggingOut}
          >
            {isLoggingOut ? <div className="spinner"></div> : "Logout"}
          </button>
        ) : (
          <Link to="/login" onClick={() => setIsNavbarSidebarOpen(false)}>
            <button className="login-button">LogIn</button>
          </Link>
        )}
      </aside>
    </nav>
  );
}

export default Navbar;
